import React from 'react'
import { string, node } from 'prop-types'
import styled from 'styled-components'

import { media } from 'styles/media'
import { white } from 'styles/colors'
import * as spacing from 'styles/spacing'
import { H1 } from 'styles/typography'
import Button from 'components/button/Button'

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  user-select: none;
  width: 100%;
  height: 100%;
  padding-bottom: 140px;
  background-color: ${props => props.backgroundColor};
`

const Inner = styled.div`
  position: relative;
  z-index: 20;
  width: 100%;
  height: 100%;
  padding: 0 ${spacing.xxLarge};
`

const Content = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: ${spacing.medium};

  ${media.small`
    padding-bottom: ${spacing.large};
  `};
`

const Name = styled(H1)`
  display: block;
  font-size: 40px;
  color: ${white};
  font-family: 'Trim Poster';
  text-transform: uppercase;

  ${media.small`
    font-size: 48px;
  `};
`

const Disclaimer = styled.span`
  font-size: 10px;
  color: ${white};
  display: block;
  margin-top: ${spacing.small};
`

const Background = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 140px);
  object-fit: cover;
  object-position: top center;
`

const Device = styled.img`
  position: static;
  width: 74px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${spacing.medium};

  ${media.small`
    width: 84px;
  `};
`

const CustomizeSlide = ({ name, backgroundColor, disclaimer, slug, link }) => (
  <Container backgroundColor={backgroundColor}>
    <Inner backgroundColor={backgroundColor}>
      <Content>
        <Device src={`${process.env.BASE_PATH}/images/home/offers/${slug}-device.png`} />
        <Name as="h3">{name}</Name>

        <Button to={link} theme="custom" variant="outline" customColor={white} size="large">
          Buy now
        </Button>

        <Disclaimer>{disclaimer}</Disclaimer>
      </Content>
    </Inner>
    <Background src={`${process.env.BASE_PATH}/images/home/offers/${slug}-mobile-bg.jpg`} />
  </Container>
)

CustomizeSlide.propTypes = {
  name: node.isRequired,
  backgroundColor: string.isRequired,
  slug: string.isRequired,
  disclaimer: string,
  link: string.isRequired,
  price: string.isRequired
}

export default CustomizeSlide
